import React, { useState, useEffect, useMemo } from "react";
// CSS
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

// ICON
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@material-ui/icons/Search";

import CircularProgress from "@mui/material/CircularProgress";

type PostSearchBoxProps = {
  // data
  label: string;
  initialValue?: string;
  textField: string;
  // callback
  onGetSearchOptions?: (params: { searchText: string }) => any;
  onSelectOption?: (item: any) => any;
  options?: any;
  loadingOptions?: boolean;
};
const defaultKey = `key-`;
/* TODO --------------------- SearchBox --------------------- */
const PostSearchBox: React.FC<PostSearchBoxProps> =
  React.memo<PostSearchBoxProps>((props) => {
    const [inputSearch, setInputSearch] = useState<any>(null);
    const [typingTimeout, setTypingTimeout] = useState<any>(null);
    const [options, setOptions] = React.useState<any[]>([]);
    const [keyOptions, setKeyOptions] = React.useState<string>(
      defaultKey + `${Date.now()}`
    );

    useEffect(() => {
      if (props.initialValue) {
        setInputSearch(props.initialValue);
      }
    }, []);

    useEffect(() => {
      setKeyOptions(defaultKey + `${Date.now()}`);
      if (!inputSearch) {
        setOptions([]);
      } else {
        setOptions(props.options);
      }
    }, [props.options]);

    const handleSearch = (e: any) => {
      const value = e.target.value;
      setInputSearch(value);

      let search = options.find(
        (items: any) => items?.[props.textField] === value
      );
      if (!search) {
        props.onSelectOption?.(null);
      }

      if (!value) {
        return;
      }

      if (typingTimeout) {
        clearTimeout(typingTimeout as any);
      }

      setTypingTimeout(
        setTimeout(() => {
          props.onGetSearchOptions?.({
            searchText: value,
          });
        }, 400)
      );
    };

    const handleSelectItem = (item: any) => {
      props.onSelectOption?.(item);
      setInputSearch(item?.[props.textField] || null);
    };

    return (
      <>
        <Autocomplete
          // key={keyOptions}
          className="PostSearchBox-root"
          // freeSolo
          id="free-solo"
          value={inputSearch}
          inputValue={inputSearch || ""}
          onChange={(event, newValue) => {
            handleSelectItem(newValue);
          }}
          popupIcon={false}
          disableClearable={!inputSearch || props.loadingOptions}
          filterSelectedOptions
          options={options}
          getOptionLabel={(option) => option?.[props.textField] || ""}
          renderInput={(params) => (
            <div style={{ position: "relative" }}>
              <TextField
                {...params}
                label={props.label}
                InputProps={{
                  ...params.InputProps,
                  type: "search",
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={handleSearch}
              />
              {!inputSearch && !props.loadingOptions && (
                <IconButton
                  aria-label="toggle visibility"
                  // onClick={handleClickShowPassword}
                  // onMouseDown={handleMouseDownPassword}
                  style={{ position: "absolute", right: "2px", top: "23px" }}
                >
                  <SearchIcon />
                </IconButton>
              )}
              {props.loadingOptions && (
                <CircularProgress
                  color="inherit"
                  size={20}
                  style={{
                    position: "absolute",
                    right: "0.76rem",
                    top: "32px",
                  }}
                />
              )}
            </div>
          )}
        />
      </>
    );
  });

PostSearchBox.defaultProps = {
  label: "",
  textField: "name",
} as PostSearchBoxProps;

export default PostSearchBox;
